import React from 'react';
import ExportServicioPaso6 from './servicios/exportServicioPaso6';
import ExportAgricolaPaso6 from './agricola/exportAgricolaPaso6';
import ExportPecuarioPaso6 from './pecuario/exportPecuarioPaso6';

const ExportPaso6 = ({ formData, styles }) => {
    if (formData?.lineaProductiva === 'Servicios') {
        return <ExportServicioPaso6 formData={formData} styles={styles} />;
    }

    if (formData?.lineaProductiva === 'Agrícola') {
        return <ExportAgricolaPaso6 formData={formData} styles={styles} />;
    }

    if (formData?.lineaProductiva === 'Pecuaria') {
        return <ExportPecuarioPaso6 formData={formData} styles={styles} />;

    }

    return null; // Manejo del caso en que ninguna condición se cumpla
};

export default ExportPaso6;
